import { render, staticRenderFns } from "./AdminPredefinedProductCategoriesEditScreen.vue?vue&type=template&id=4c853874&scoped=true&"
import script from "./AdminPredefinedProductCategoriesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminPredefinedProductCategoriesEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c853874",
  null
  
)

export default component.exports